export var EventInputType = /* @__PURE__ */ ((EventInputType2) => {
  EventInputType2["DRAG"] = "drag";
  EventInputType2["KEYBOARD"] = "keyboard";
  EventInputType2["MOUSE"] = "mouse";
  EventInputType2["POINTER"] = "pointer";
  EventInputType2["TOUCH"] = "touch";
  EventInputType2["WINDOW"] = "window";
  return EventInputType2;
})(EventInputType || {});
